/**
 * MessageBody — renders a kontakt message (`zprava`).
 *
 * Messages can arrive as plain text (typed by a seller) or as HTML markup
 * (LMS-sourced cenová nabídka / testovací jízda payloads carry tables, links,
 * line breaks). Mirrors the legacy heuristic in
 * `src/kontakty/upravit_kontakt.js:137-142`: if the body looks like HTML,
 * render it as markup; otherwise treat it as plain text.
 *
 * Unlike the legacy page — which injected the raw string via `innerHTML` — we
 * sanitize HTML through DOMPurify first, so a malicious message can't inject
 * scripts or event handlers into the React tree.
 */

import DOMPurify from 'dompurify';

const HTML_TAG = /<[a-z][\s\S]*>/i;

export function MessageBody({ zprava }: { zprava: string }) {
  const text = zprava ?? '';

  if (HTML_TAG.test(text)) {
    const clean = DOMPurify.sanitize(text);
    return (
      <span
        className="block text-[11.5px] leading-[1.55] text-ink-2 [&_a]:text-accent-text [&_a]:underline [&_table]:my-1 [&_td]:pr-3"
        // Sanitized above with DOMPurify — safe to inject.
        dangerouslySetInnerHTML={{ __html: clean }}
      />
    );
  }

  return (
    <span className="block whitespace-pre-line text-[11.5px] text-ink-2">{text}</span>
  );
}
